import React from "react";
import styles from "./style.module.scss";
import { translate } from "@helpers/translationObjectFormatter";
import { TranslationsObject } from "@genericTypes/sharedTypes";
import { useQuery } from "@tanstack/react-query";
import LifeStyle from "./logos/lifeStyle";
import BusinessServices from "./logos/businessServices";
import FinancialServices from "./logos/financialServices";
const Industries = () => {
    const { data: translations } = useQuery<TranslationsObject>([
        "translations",
    ]);
    return (
        <section className={`${styles["mainContainer"]} mt-16`}>
            <div className="pt-16 pb-28">
                <h2 className=" text-center font-extrabold lg:text-4xl text-3xl leading-9">
                    {translate(
                        translations,
                        "several_partnerWithUsPage_industriesTitle",
                    )}
                </h2>
                <div
                    className={`${styles["innerContainer"]} flex flex-col lg:flex-row  w-fit mx-auto gap-10 lg:gap-0 lg:w-auto justify-between mt-10`}
                >
                    <div>
                        <div className=" w-fit mx-auto">
                            <LifeStyle />
                        </div>
                        <h3>
                            {translate(
                                translations,
                                "several_partnerWithUsPage_LifestyleAndTechTitle",
                            )}
                        </h3>
                    </div>
                    <div>
                        <div className=" w-fit mx-auto">
                            <BusinessServices />
                        </div>
                        <h3>
                            {translate(
                                translations,
                                "several_partnerWithUsPage_BusinessServicesTitle",
                            )}
                        </h3>
                    </div>
                    <div>
                        <div className=" w-fit mx-auto">
                            <FinancialServices />
                        </div>
                        <h3>
                            {translate(
                                translations,
                                "several_partnerWithUsPage_FinancialServicesTitle",
                            )}
                        </h3>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Industries;
